import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'

const app = createApp(App)

if (import.meta.env.VITE_DEBUG === 'true') {
  app.config.performance = true
  const hook = (window as any).__VUE_DEVTOOLS_GLOBAL_HOOK__
  if (hook) hook.enabled = true
}

app.use(createPinia())
app.use(router)
app.use(vuetify)

app.mount('#app')
